import React, { useEffect } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Footer from "../components/footer"
import { Player } from "@lottiefiles/react-lottie-player"
import GenericImage from "../components/generic-image"
import WorkPageAnimation from "../lottie/works"
import Transition from "./transition"
import AniLink from "gatsby-plugin-transition-link/AniLink"

export default class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: false,
    }
  }

  componentDidMount() {
    if (!this.state.isMobile) {
      if (window.innerWidth <= 575) {
        this.setState({ isMobile: true })
      }
    }
  }

  footerText = () => {
    return (
      <>
        Virtual coffee. Video meetings.
        <br />
        For these extraordinary times.
      </>
    )
  }

  render() {
    return (
      <Layout hideNavigator>
        <SEO title="Mobiux | App and Website Design and Development Company" pathname="/works" />
        <div className="container-fluid home-page">
          <section className="landing-head-section">
            <div className="container">
              <div className="row align-items-center banner-section">
                <div className="col-md-6 banner-heading">
                  <Transition
                    data={
                      <>
                        <h1 className="heading text-white">
                          Our Work goes to Play
                        </h1>
                        <p className="text-white pt-3">
                          In the marketplace. In e-commerce. In branding. In
                          websites and apps. To deliver results.
                        </p>
                      </>
                    }
                  />
                </div>
                <div className="col-md-6 pt-md-5">
                  <Player autoplay loop={true} src={WorkPageAnimation}></Player>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="container">
              <div
                className="row align-items-center glance-valueable-initiative"
                style={
                  this.state.isMobile
                    ? { minHeight: "300px" }
                    : { minHeight: "400px" }
                }
              >
                <div className="col-md-6">
                  <Transition
                    data={
                      <>
                        <h1 className="heading p-2">Built in our labs</h1>
                      </>
                    }
                  />
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="container">
              <div className="row d-flex justify-content-around works-section">
                <div className="col-md-6 ">
                  <AniLink
                    cover
                    direction="down"
                    bg="#000000"
                    duration={1}
                    to="/redseer/"
                  >
                    <div className="works">
                      <GenericImage filename="works/redseer.png" />
                      <div className="works-text">
                        <div className="max-title-width">
                          <Transition
                            data={
                              <>
                                <h1>Redseer Strategic Consultants</h1>
                                <p>Development, Design</p>
                              </>
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </AniLink>
                  <AniLink
                    cover
                    direction="down"
                    bg="#000000"
                    duration={1}
                    to="/warburtons/"
                  >
                    <div className="works">
                      <GenericImage filename="works/warburtons.png" />
                      <div className="works-text">
                        <div className="max-title-width">
                          <Transition
                            data={
                              <>
                                <h1>Warburtons Glutenfree</h1>
                                <p>Development, Design</p>
                              </>
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </AniLink>
                  <AniLink
                    cover
                    direction="down"
                    bg="#000000"
                    duration={1}
                    to="/deal-street-asia/"
                  >
                    <div className="works">
                      <GenericImage filename="works/dealstreetasia.png" />
                      <div className="works-text">
                        <Transition
                          data={
                            <>
                              <h1>DealStreetAsia</h1>
                              <p>Development, Design</p>
                            </>
                          }
                        />
                      </div>
                    </div>
                  </AniLink>
                  <AniLink
                    cover
                    direction="down"
                    bg="#000000"
                    duration={1}
                    to="/faster-fit-case-study/"
                  >
                    <div className="works">
                      <GenericImage filename="works/faster-fit.png" />
                      <div className="works-text">
                        <Transition
                          data={
                            <>
                              <h1>Faster.fit</h1>
                              <p>Branding, Web, Mobile</p>
                            </>
                          }
                        />
                      </div>
                    </div>
                  </AniLink>
                  <AniLink
                    cover
                    direction="down"
                    bg="#000000"
                    duration={1}
                    to="/footprints/"
                  >
                    <div className="works">
                      <GenericImage filename="works/footprints.png" />
                      <div className="works-text">
                        <Transition
                          data={
                            <>
                              <h1>Footprints</h1>
                              <p>Web, Mobile, Branding</p>
                            </>
                          }
                        />
                      </div>
                    </div>
                  </AniLink>
                  <AniLink
                    cover
                    direction="down"
                    bg="#000000"
                    duration={1}
                    to="/insurecomp/"
                  >
                    <div className="works">
                      <GenericImage filename="works/insure-comp.png" />
                      <div className="works-text">
                        <Transition
                          data={
                            <>
                              <h1>InsureComp</h1>
                              <p>Web</p>
                            </>
                          }
                        />
                      </div>
                    </div>
                  </AniLink>
                  <AniLink
                    cover
                    direction="down"
                    bg="#000000"
                    duration={1}
                    to="/connect-direct-services/"
                  >
                    <div className="works">
                      <GenericImage filename="works/connect-direct-service.png" />
                      <div className="works-text">
                        <Transition
                          data={
                            <>
                              <h1>ConnectDirectServices</h1>
                              <p>Branding, Motion</p>
                            </>
                          }
                        />
                      </div>
                    </div>
                  </AniLink>
                </div>
                <div className="col-md-6 pl-md-3">
                  <AniLink
                    cover
                    direction="down"
                    bg="#000000"
                    duration={1}
                    to="/artha/"
                  >
                    <div className="works">
                      <GenericImage filename="works/artha.png" />
                      <div className="works-text">
                        <div className="max-title-width">
                          <Transition
                            data={
                              <>
                                <h1>Artha School of Entrepreneurship</h1>
                                <p>Development, Design</p>
                              </>
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </AniLink>
                  <AniLink
                    cover
                    direction="down"
                    bg="#000000"
                    duration={1}
                    to="/bakers-market/"
                  >
                    <div className="works">
                      <GenericImage filename="works/bakers-market.png" />
                      <div className="works-text">
                        <Transition
                          data={
                            <>
                              <h1>BakersMarket</h1>
                              <p>Development, Design</p>
                            </>
                          }
                        />
                      </div>
                    </div>
                  </AniLink>
                  <AniLink
                    cover
                    direction="down"
                    bg="#000000"
                    duration={1}
                    to="/niradhi/"
                  >
                    <div className="works">
                      <GenericImage filename="works/niradhi.png" />
                      <div className="works-text">
                        <Transition
                          data={
                            <>
                              <h1>Niradhi</h1>
                              <p>Branding</p>
                            </>
                          }
                        />
                      </div>
                    </div>
                  </AniLink>
                  <AniLink
                    cover
                    direction="down"
                    bg="#000000"
                    duration={1}
                    to="/apnahood/"
                  >
                    <div className="works">
                      <GenericImage filename="works/apnahood.png" />
                      <div className="works-text">
                        <Transition
                          data={
                            <>
                              <h1>Apnahood</h1>
                              <p>Social, E-commerce</p>
                            </>
                          }
                        />
                      </div>
                    </div>
                  </AniLink>
                  <AniLink
                    cover
                    direction="down"
                    bg="#000000"
                    duration={1}
                    to="/network-insights/"
                  >
                    <div className="works">
                      <GenericImage filename="works/network-insight.png" />
                      <div className="works-text">
                        <Transition
                          data={
                            <>
                              <h1>NetworkInsights</h1>
                              <p>Web</p>
                            </>
                          }
                        />
                      </div>
                    </div>
                  </AniLink>
                </div>
              </div>
            </div>
          </section>
          <Footer contactTitle={this.footerText()} />
        </div>
      </Layout>
    )
  }
}
